export const OAUTH_URL = 'https://auth.emergentagent.com';

export const getRedirectUrl = () => {
  return `${window.location.origin}/login`;
};

export const initiateGoogleLogin = () => {
  const redirectUrl = getRedirectUrl();
  const appName = process.env.REACT_APP_NAME || 'The Haute Circle';
  window.location.href = `${OAUTH_URL}/?redirect=${encodeURIComponent(redirectUrl)}&app_name=${encodeURIComponent(appName)}&hide_branding=true`;
};

export const getSessionIdFromUrl = () => {
  const hash = window.location.hash;
  if (hash && hash.includes('session_id=')) {
    const sessionId = hash.split('session_id=')[1].split('&')[0];
    return sessionId;
  }
  return null;
};

export const clearSessionIdFromUrl = () => {
  window.history.replaceState(null, '', window.location.pathname);
};

// Apple Sign In
export const initiateAppleLogin = () => {
  // TODO: Implement Apple Sign In
  // This will require Apple Developer account and Sign in with Apple setup
  // For now, showing a toast message
  console.log('Apple Sign In - Integration pending');
};

// Facebook Sign In
export const initiateFacebookLogin = () => {
  // TODO: Implement Facebook Login
  // This will require Facebook App ID and Facebook Login SDK
  // For now, showing a toast message
  console.log('Facebook Sign In - Integration pending');
};
